import React, { memo } from 'react';
import { Layout, Row, Typography } from 'antd';
import { Navigate, Outlet } from 'react-router';
import { useSelector } from 'react-redux';
import { userSelectors } from '@features/user';
import { ROUTES } from '@features/navigation';

export const UnAuthenticatedLayout = memo(() => {
  const { Header, Content, Footer } = Layout;

  const user = useSelector(userSelectors.userData);

  if (user) {
    return <Navigate to={ROUTES.CLIENTS.path} />;
  }

  return (
    <Layout style={{ height: '100vh' }}>
      <Header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          width: '100%',
        }}
      >
        <Row
          align='middle'
          style={{
            height: '4rem',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Typography.Title level={2} style={{ color: 'white', fontWeight: 700, margin: 0 }}>
            Logisped
          </Typography.Title>
        </Row>
      </Header>
      <Content
        className='site-layout'
        style={{
          padding: '50px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Outlet />
      </Content>
      <Footer
        style={{
          textAlign: 'center',
        }}
      >
        Logisped ©{new Date().getFullYear()}
      </Footer>
    </Layout>
  );
});

UnAuthenticatedLayout.displayName = 'UnAuthenticatedLayout';
